var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "page-title" }, [_vm._v("我的审批")]),
        _c("div", { staticClass: "page-sub" }, [
          _vm._v(
            "我提交的所有审批申请 · 共 " + _vm._s(_vm.list.length) + " 条"
          ),
        ]),
      ]),
      _c(
        "el-card",
        { staticClass: "filter-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true, size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "业务类型" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "160px" },
                    attrs: { placeholder: "全部", clearable: "" },
                    model: {
                      value: _vm.filter.bizType,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "bizType", $$v)
                      },
                      expression: "filter.bizType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "全部", clearable: "" },
                      model: {
                        value: _vm.filter.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "status", $$v)
                        },
                        expression: "filter.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "审批中", value: 0 } }),
                      _c("el-option", { attrs: { label: "已完成", value: 1 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-refresh" },
                      on: { click: _vm.load },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { "margin-top": "12px" },
          attrs: { data: _vm.filtered },
          on: { "row-click": _vm.goDetail },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", width: "60", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "业务类型", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-tag", { attrs: { size: "small", type: "info" } }, [
                      _vm._v(_vm._s(row.businessType)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", { attrs: { label: "标题", prop: "title" } }),
          _c("el-table-column", {
            attrs: { label: "状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tag",
                      { attrs: { size: "small", type: _vm.statusType(row) } },
                      [_vm._v(_vm._s(_vm.statusText(row)))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "当前节点/结果" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.status === 0
                      ? _c("span", [
                          _vm._v(" 正在等待 "),
                          _c("b", [_vm._v(_vm._s(row.currentTaskName || "—"))]),
                          _vm._v(
                            " (审批人: " +
                              _vm._s(row.currentAssigneeName || "待分配") +
                              ") 审批 "
                          ),
                        ])
                      : row.result === 1
                      ? _c("span", { staticStyle: { color: "#f56c6c" } }, [
                          _vm._v(
                            " 已驳回:" + _vm._s(row.comment || "(无原因)") + " "
                          ),
                        ])
                      : row.result === 0
                      ? _c("span", { staticStyle: { color: "#67c23a" } }, [
                          _vm._v("审批通过 ✓"),
                        ])
                      : _c("span", { staticStyle: { color: "#909399" } }, [
                          _vm._v("已撤回"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "提交时间", prop: "startTime", width: "160" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "240" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.goDetail(row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    row.status === 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              loading: _vm.urgingId === row.id,
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.urgeRow(row)
                              },
                            },
                          },
                          [_vm._v("催办")]
                        )
                      : _vm._e(),
                    row.status === 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.withdrawRow(row)
                              },
                            },
                          },
                          [_vm._v("撤回")]
                        )
                      : _vm._e(),
                    row.status === 1 && row.result === 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.editRejected(row)
                              },
                            },
                          },
                          [_vm._v("修改重提")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }